import { render, staticRenderFns } from "./ArmsRegArchiveLossInfo.vue?vue&type=template&id=fd500f94&scoped=true&"
import script from "./ArmsRegArchiveLossInfo.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveLossInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd500f94",
  null
  
)

export default component.exports